export default __webpack_public_path__ + "static/media/Gunjan_sinha.09ef2624.png";